<template>
  <div class="booking-history__container">
    <el-table
      :data="bookingHistories"
      class="fifl-main-table booking-history-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      row-class-name="fifl-table-row"
      cell-class-name="fifl-main-table-cell"
      height="100%"
    >
      <el-table-column
        sortable
        prop="status_changed"
        label="일시"
        width="150"
      >
        <template slot-scope="scope">
          <span :class="getRecordClass(scope.row)">
            {{ format(scope.row.status_changed, 'YYYY.MM.DD HH:mm:ss') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="member_name"
        label="회원"
      >
        <template slot-scope="scope">
          <span :class="getRecordClass(scope.row)">
            {{ scope.row.member_name }}{{ scope.row.enrollment_is_removed ? ' ' + '(삭제됨)' : '' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="상태"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="getRecordClass(scope.row)">
            {{ PRESENT_BOOKING_STATUS[scope.row.status] }}
          </span>
        </template>
      </el-table-column>

      <div slot="empty">
        <div
          v-show="bookingHistories.length === 0"
          class="empty-message"
        >
          <warning-message
            :message="emptyMessage"
          />
        </div>
      </div>
    </el-table>
  </div>
</template>

<script>
import _ from 'lodash';
import { format, compareAsc } from 'date-fns';
import { fiflboxApi } from '@/utils/api';
import WarningMessage from '@/components/element-ui/WarningMessage';

const PRESENT_BOOKING_STATUS = {
  BOOKED: '예약',
  CANCELLED: '취소',
  ABSENCE: '결석',
  NOSHOW: '예약',
  ATTENDANCE: '출석',
  LATE: '지각',
  WAITING: '대기',
  WAIT_CANCELLED: '대기 취소',
  WAIT_BOOKED: '예약 확정',
  AUTO_CANCELLED: '대기 자동 취소',
  FORCE_CANCELLED: '대기 자동 취소'
};

export default {
  name: 'BookingHistory',
  components: { WarningMessage },
  props: ['childCourse'],
  data() {
    return {
      PRESENT_BOOKING_STATUS,
      bookingHistories: []
    };
  },
  computed: {
    emptyMessage() {
      return `${this.isBookingSystem ? '예약' : '수강'} 내역이 없습니다`;
    },
    isBookingSystem() {
      return this.$store.getters.getIsBookingSystem;
    }
  },
  watch: {
    childCourse: {
      immediate: true,
      handler(value) {
        if (!value.id) return;
        this.syncBookingHistoryData();
      }
    }
  },
  methods: {
    format,
    getRecordClass({ isLastBooking, status }) {
      return {
        'last-record': isLastBooking
      };
    },
    async syncBookingHistoryData() {
      const params = {
        child_course: this.childCourse.id,
        dt: this.childCourse.dt,
        status: [
          'BOOKED',
          'CANCELLED',
          'ABSENCE',
          'ATTENDANCE',
          'LATE',
          'NOSHOW',
          'WAITING',
          'WAIT_CANCELLED',
          'FORCE_CANCELLED',
          'WAIT_BOOKED'
        ]
      };
      if (this.childCourse.is_booking_expired) {
        params.status.push('AUTO_CANCELLED');
      }
      const {
        data: bookingHistories
      } = await fiflboxApi.v1.getBookingHistories(params);
      const lastMemberChecked = {};
      this.bookingHistories = [];

      _.forEachRight(bookingHistories, (bookingHistory, index) => {
        if (
          bookingHistories[index + 1] &&
          bookingHistories[index + 1].status === 'CANCELLED' &&
          bookingHistory.status === 'NOSHOW'
        ) {
          return;
        }

        let latestBookedIdx = index;
        // 1. 체크 된 회원이라면, 최신 여부를 비교하여 인덱스 업데이트
        if (lastMemberChecked.hasOwnProperty(bookingHistory.member_name)) {
          const latestHistory =
            bookingHistories[lastMemberChecked[bookingHistory.member_name]];

          let result =
            new Date(bookingHistory.status_changed) >
            new Date(latestHistory.status_changed);

          bookingHistory.isLastBooking = result;
          if (result) {
            bookingHistories[
              lastMemberChecked[bookingHistory.member_name]
            ].isLastBooking = false;
            latestBookedIdx = index;
          } else {
            latestBookedIdx = lastMemberChecked[bookingHistory.member_name];
          }
        }
        // 2. 체크되지 않은 회원이라면, 그대로 최신 회원 인덱스 할당 및 저장.
        else {
          bookingHistory.isLastBooking = true;
        }

        // 가장 최신 회원 히스토리로 결정된 인덱스를 저장
        lastMemberChecked[bookingHistory.member_name] = latestBookedIdx;
        this.bookingHistories.push(bookingHistory);
      });

      this.bookingHistories.sort((a, b) =>
        compareAsc(a.status_changed, b.status_changed)
      );
    }
  }
};
</script>

<style lang="scss">
.booking-history__container {
  width: 100%;
  height: 100%;
  padding: 20px 30px 30px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 20px 20px 30px;
  }
}

.booking-history-table {
  .last-record {
    font-weight: bold;
  }

  @media screen and (max-width: 768px) {
    height: 350px;
  }
}
</style>
